import ctl from '@netlify/classnames-template-literals'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { router } from '@inertiajs/react'

type TProps = {}

type TOption = {
  label: string
  value: string
}

const LangSelector: FC<TProps> = () => {
  const { t, i18n } = useTranslation(ClientLocaleNS.Common)
  const options: TOption[] = [
    {
      label: t('lang.en'),
      value: 'en',
    },
    {
      label: t('lang.am'),
      value: 'am',
    },
  ]

  return (
    <div className="flex w-full">
      <Select
        unstyled
        isSearchable={false}
        menuPlacement="top"
        value={options.find((item) => item.value === i18n.language)}
        classNames={{
          container: () => ctl(`bg-palette-grey-10 w-full max-w-[283px] h-12 font-body---16px`),
          control: (state) =>
            ctl(
              `bg-palette-grey--10 w-full text-palette-grey--50 px-4 h-full rounded-md !cursor-pointer hover:text-palette-white transition-colors ${state.menuIsOpen && 'rounded-t-none'}`,
            ),
          option: () =>
            ctl(
              `bg-palette-grey--10 w-full text-palette-grey--50 px-4 py-3 hover:text-palette-white !cursor-pointer transition-colors`,
            ),
          menu: () => ctl(`bg-palette-black rounded-t-md overflow-hidden`),
        }}
        options={options}
        onChange={(option) => {
          router.get(`/lang/${option?.value}`, {}, { preserveScroll: true })
          i18n.changeLanguage(option?.value)
        }}
      />
    </div>
  )
}

export { LangSelector }
